import type { IconSvgObject } from './types';

const DashedLine02Icon: IconSvgObject = [
  ["path", { d: "M6.5 2.5H4.5C3.39543 2.5 2.5 3.39543 2.5 4.5V6.5M17.5 2.5H19.5C20.6046 2.5 21.5 3.39543 21.5 4.5V6.5M2.5 17.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H6.5M17.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 2.5H14M10 21.5H14M21.5 10V14M2.5 10L2.5 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default DashedLine02Icon;
